var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStockout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "30px",
    viewBox: "0 0 34 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Global / Icons / Notifications / Stockout") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Global-/-Icons-/-Notifications-/-Stockout",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FF5676",
    x: 0,
    y: 0,
    width: 34,
    height: 30,
    rx: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1421356,14.1421356 L21.1421356,14.1421356 L21.1421356,16.1421356 L18.1421356,16.1421356 L18.1421356,19.1421356 L16.1421356,19.1421356 L16.1421356,16.1421356 L13.1421356,16.1421356 L13.1421356,14.1421356 L16.1421356,14.1421356 L16.1421356,11.1421356 L18.1421356,11.1421356 L18.1421356,14.1421356 Z M17.1421356,23.1421356 C12.7311356,23.1421356 9.14213562,19.5531356 9.14213562,15.1421356 C9.14213562,10.7311356 12.7311356,7.14213562 17.1421356,7.14213562 C21.5531356,7.14213562 25.1421356,10.7311356 25.1421356,15.1421356 C25.1421356,19.5531356 21.5531356,23.1421356 17.1421356,23.1421356 L17.1421356,23.1421356 Z M17.1421356,5.14213562 C11.6191356,5.14213562 7.14213562,9.61913562 7.14213562,15.1421356 C7.14213562,20.6651356 11.6191356,25.1421356 17.1421356,25.1421356 C22.6651356,25.1421356 27.1421356,20.6651356 27.1421356,15.1421356 C27.1421356,9.61913562 22.6651356,5.14213562 17.1421356,5.14213562 L17.1421356,5.14213562 Z",
    id: "plus_circle-[#1441]",
    fill: "#FFFFFF",
    transform: "translate(17.142136, 15.142136) rotate(-315.000000) translate(-17.142136, -15.142136) "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStockout);
export default __webpack_public_path__ + "static/media/stockout.24b81c38.svg";
export { ForwardRef as ReactComponent };